import { useRef } from 'react';
import { getLabelsByLanguage } from '../../../../utilites/util';

interface Props {
  onClose?: Function;
}
const SuccessMessage: React.FC<Props> = ({ onClose }) => {
  const searchParams = new URL(window.location.toString()).searchParams;
  const orderNumber = searchParams.get('orderNumber') || '';

  const labels = getLabelsByLanguage();
  const msgRef = useRef<HTMLElement>(null);

  const handleClose = () => {
    if (onClose) {
      onClose();
      return;
    }

    if (msgRef.current) {
      msgRef.current.setAttribute('data-ytope-message', 'inactive');
    }
  };

  return (
    <section className="ytope-message ytope-message--success" data-ytope-message="active" ref={msgRef}>
      <div className="ytope-message__close" data-ytope-close="" onClick={handleClose}></div>
      <div className="ytope-message__content" data-ytope-message-content="">
        <p className="mb-2">{labels.topupSuccess.replace('%', orderNumber)}</p>
      </div>
    </section>
  );
};

export default SuccessMessage;
